import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';

import axios from 'axios';
import Keycloak from 'keycloak-js';
import VueLogger from 'vuejs3-logger';

import { VueReCaptcha } from 'vue-recaptcha-v3';

import Framework7 from 'framework7/lite-bundle';
import Framework7Vue, { registerComponents } from 'framework7-vue/bundle';

import '../css/icons.css';
import '../css/app.less';

import 'framework7/framework7-bundle.css';

import App from '../components/app.vue';

Framework7.use(Framework7Vue);
const app = createApp(App);

//import interceptorsSetup from './interceptor.js';
//interceptorsSetup();

registerComponents(app);

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: window.session_lang || "ro",
  fallbackLocale: "ro",
  messages: {
    ro: require('../lang/ro.json'),
    en: require('../lang/en.json'),
  },
});

app.use(i18n);
app.use(VueReCaptcha, { siteKey: '6LeoOPcfAAAAAIyWDOXZXjFEaeWX6eC6TnzJbaUa', loaderOptions: { autoHideBadge: true, useRecaptchaNet: true } });

const logger_opt = {
  isEnabled: true,
  logLevel : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};
app.use(VueLogger, logger_opt);

// Global properties
app.config.globalProperties.$i18n=i18n;
app.config.globalProperties.$http=axios;
app.config.globalProperties.$token=window.token
app.config.globalProperties.$session_theme=window.session_theme
app.config.globalProperties.$session_logo=window.session_logo
app.config.globalProperties.$session_client_id=window.session_client_id || 'direct'

app.config.globalProperties.$ice_server_urls=window.ice_server_urls;
app.config.globalProperties.$ice_server_username=window.ice_server_username;
app.config.globalProperties.$ice_server_credential=window.ice_server_credential;

app.config.globalProperties.$janus_debug=window.janus_debug;
app.config.globalProperties.$janus_url=window.janus_url_list.split(',');

// Global error handler
app.config.errorHandler = (err, instance, info) => {
  // Handle the error globally
  console.log("Global error:", err);
  console.log("Vue instance:", instance);
  console.log("Error info:", info);
  // Add code for UI notifications, reporting or other error handling logic
};

localStorage.token=window.token

const keycloak=new Keycloak({
  url: window.keycloak_edit_url,
  realm: window.keycloak_edit_realm,
  clientId: window.keycloak_edit_client_id,
});

keycloak.onAuthError = (errorData) => {
  if (errorData.error === 'access_denied') {
    console.log('Access denied - user refused to grant access to resource or cancelled the login request');
  } else {
    console.log('Auth error', errorData);
  }
};

if(app.config.globalProperties.$session_client_id=='direct') { 
  keycloak.init({
    checkLoginIframe: false,
    onLoad: 'check-sso',
    enableLogging: false,
    flow: 'standard',
    silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
  })
  .then(function(athenticated) {
    app.config.globalProperties.$keycloak=keycloak;
    app.mount('#app');
  })
  .catch(function(error) {
    app.config.globalProperties.$keycloak=keycloak;
    app.mount('#app');
  });
} else {
  console.log("no keycloak");
  app.config.globalProperties.$keycloak=null;
  app.mount('#app');
}

